import * as _ from 'lodash';
import { StudentPanel } from '../../../../ng2/shared/constants/student-panel.constant';
import { LocalStorageService } from './../../../../ng2/shared/services/web-storage/local-storage/local-storage.service';

angular.module('nv.singleStudent').controller('ssvPanelStatusWidgetCtrl', ssvPanelStatusWidgetCtrl);

function ssvPanelStatusWidgetCtrl(LocalStorageService: LocalStorageService) {
  const self = this;

  self.getCountHidden = () => {
    const hiddenPanelCollection = LocalStorageService.getItem('ssvHiddenPanels');
    return hiddenPanelCollection.length;
  };

  // creates model for checkboxes within md-menu
  self.createMenuModel = menuConst => {
    const menuObject = {};
    _.forOwn(menuConst, v => {
      menuObject[v.id] = true;
    });
    return menuObject;
  };

  self.panelMenu = self.createMenuModel(StudentPanel);

  // set 'all' based on visible hidden/shown panels: all panels selected
  self._selectAllIsChecked = panelMenu => {
    return _.every(panelMenu, v => v);
  };

  // set 'all' based on hidden/shown panels: not all false, not all true
  self._selectAllIsIndeterminate = panelMenu => {
    return !_.every(_.values(panelMenu), v => v) && !_.every(panelMenu, v => !v);
  };

  self.getSelectAllState = panelMenu => {
    if (self._selectAllIsChecked(panelMenu)) {
      return 'checked';
    } else if (self._selectAllIsIndeterminate(panelMenu)) {
      return 'indeterminate';
    } else {
      return;
    }
  };

  // toggle menu correctly based on state of 'all':
  self.toggleAll = (panelMenu, currentSelectAllState) => {
    _.forOwn(panelMenu, (v, k) => {
      panelMenu[k] = currentSelectAllState !== 'checked';
    });
  };

  self.getHumanName = key => {
    return _.find(StudentPanel, { id: key }).human;
  };

  // open menu on widget click:
  self.openMenu = ($mdOpenMenu, ev) => {
    const hiddenPanelCollection = LocalStorageService.getItem('ssvHiddenPanels');
    _.forEach(hiddenPanelCollection, hiddenPanel => {
      self.panelMenu[hiddenPanel] = false;
      self.countHidden++;
    });
    $mdOpenMenu(ev);
  };

  // apply button:
  self.apply = () => {
    const self = this;
    self.countHidden = 0;
    const hiddenPanels = [];
    _.forOwn(self.panelMenu, (v, k) => {
      if (v === false) {
        hiddenPanels.push(k);
        self.countHidden++;
      }
    });
    LocalStorageService.setItem('ssvHiddenPanels', hiddenPanels);
  };
}
